import { render, staticRenderFns } from "./MenuTopPage.vue?vue&type=template&id=9a9a73b0&scoped=true&"
import script from "./MenuTopPage.vue?vue&type=script&lang=ts&"
export * from "./MenuTopPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9a73b0",
  null
  
)

export default component.exports